export default __webpack_public_path__ + "5420ffa1728f12a700dc819f35b43534.svg";